import type Konva from "konva";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { getCanvasState } from "../../lib/schedule-art/canvas-state";

export function applyGraphicsPreview(layer: Konva.Layer) {
  const { developerMode } = getCanvasState();
  const { graphicsOpacity, grayscale } = useMetadataEditingStore.getState();
  const canvas = layer.getNativeCanvasElement();
  canvas.style.opacity = String(developerMode ? graphicsOpacity / 100 : 1);
  canvas.style.filter = developerMode && grayscale ? "grayscale(1)" : "none";
}
